import { useSankeyRenderContext } from '../../contexts/sankeyRenderContext';
import { SankeyFlow, SankeyNode } from '../../diagram/types';
import SankeyFlowPath from './SankeyFlowPath';
import SankeyLabel from './SankeyLabel';
import SankeyNodeRectangle from './SankeyNodeRectangle';

type Props = {
  nodes: SankeyNode[];
  flows: SankeyFlow[];
  opacity?: number;
};

const SankeyNodesAndFlows: React.FC<Props> = ({
  nodes,
  flows,
  opacity = 1,
}) => {
  const { cfg } = useSankeyRenderContext();

  return (
    <g opacity={opacity}>
      <g id="sankey_flows">
        {flows.map((flow) => (
          <SankeyFlowPath key={flow.id} flow={flow} />
        ))}
      </g>
      <g id="sankey_nodes">
        {nodes.map((node) => (
          <SankeyNodeRectangle key={node.id} node={node} />
        ))}
      </g>
      {cfg.show_labels && (
        <g id="sankey_labels">
          {nodes.map((node) => (
            <SankeyLabel key={node.id} node={node} />
          ))}
        </g>
      )}
    </g>
  );
};

export default SankeyNodesAndFlows;
